import { Store } from "lucide-react";
import { EmptyState } from "@/components/ui/LoadingStates";

// Per-organization vendor assignment is not connected to a backend endpoint yet.
// The previous implementation rendered fabricated data and faked success toasts
// against a non-existent per-organization vendors surface. Until a real endpoint
// exists, the tab honestly reports that it is unavailable.
export default function VendorsTab() {
  return (
    <EmptyState
      icon={Store}
      title="Vendor assignments not available yet"
      description="Per-organization vendor assignment is not connected to a backend endpoint yet."
    />
  );
}
